module.exports = __webpack_public_path__ + "img/idx-logo1.88f91c05.png";